<template>
  <div id="establishments-main">
    <div class="horizontal-fixed-menu">
      <navigation :options="options" />
    </div>
    <div class="fixed-content">
      <router-view :config="config" />
    </div>
  </div>
</template>
<script>
import navigation from '@/components/establishments/main/navigation'

function option (vm, id, save, config, field, text, tooltip, disabled) {
  return {
    id: id,
    config: config,
    field: field,
    text: text,
    tooltip: tooltip,
    disabled: disabled,
    save: save,

    click: function () {
      config[field] = !config[field]
      if (save != null) {
        vm.$store.dispatch(`user/${save}`, config[field] ? 2 : 1)
      }
    }
  }
}

export default {
  name: 'establishments-main',
  components: {
    navigation
  },
  data: function () {
    const { getters } = this.$store
    const first = !getters['user/firstCheat']
    const config = {
      sheet: {
        showHints: getters['user/showHints'],
        autoNext: getters['user/autoNext'],
        cheatsheet: first && false
      },

      general: {
        fixedNav: getters['user/fixedNav']
      }
    }

    const vm = this
    const hints = option(
      vm, 'show-hints', 'showHints', config.sheet, 'showHints',
      'Aide à la saisie',
      `Affiche l'aide à la saisie sur le champ sélectionné (vue fiche)`
    )

    const autoNext = option(
      vm, 'auto-next', 'autoNext', config.sheet, 'autoNext',
      'Validation automatique',
      `Active la validation automatique des champs après un court délai (vue fiche)`
    )

    return {
      options: [ autoNext, hints ],
      config: config
    }
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#establishments-main {
  min-height: 100vh;

  .horizontal-fixed-menu {
    display: inline;
    @media (min-width: @screen-sm-max) {
      float: left;
    }
  }

  .fixed-content {
    overflow: hidden;
  }
}
</style>
